
import _ from 'lodash'

export default {
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
        slug: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: 'Select Your Plan',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        searchable: {
            type: Boolean,
            default: true,
        },
        internalSearch: {
            type: Boolean,
            default: false,
        },
        showNoOptions: {
            type: Boolean,
            default: false,
        },
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        helpText: {
            type: String,
            default: null,
        },
        searchParams: {
            type: Object,
            default: () => ({}),
        }
    },
    data () {
        return {
            selectableOptions: [],
            groupPlanValue: null,
        }
    },
    async fetch () {
        const query = this.query || ''
        const params = { ...this.searchParams, query }
        const items = await this.$api.getGroupPlansFromCopays(this.slug, params)
        this.selectableOptions = items?.length ? items : []
    },
    watch: {
        value () {
            if (!_.isEqual(parseInt(this.value), this.groupPlanValue?.value)) {
                this.updateValue()
            }
        },
        searchParams: {
            deep: true,
            handler () {
                this.$fetch()
            }
        },
        groupPlanValue () {
            this.emitInput()
        },
        'selectableOptions.length' () {
            this.updateValue()
        }
    },
    mounted () {
        this.updateValue()
    },
    methods: {
        updateValue () {
            if (!this.selectableOptions?.length) {
                return
            }
            if (this.value) {
                const groupPlan = this.selectableOptions.find(option => option.value === this.value)
                this.groupPlanValue = groupPlan
            } else {
                this.groupPlanValue = null
            }
        },
        emitInput () {
            this.$emit('input', this.groupPlanValue?.value || null)
            this.$emit('input-raw', this.groupPlanValue || null)
        },
        search (query) {
            this.query = query
            return this.$fetch()
        },
    },
}
